import React from 'react';
import PropTypes from 'prop-types';
import { SvgHamburger, SvgArrow } from 'components/Svgs';
import VenueSelector from 'components/VenueSelector';

import { PrivacyFooter } from 'features/Privacy';
import { classNameWithModifiers as withMods } from 'helpers/class-name';

import './PrivacyFooterLayout.scss';
import {
  BackNavLinkContext,
  HeaderContext,
  ControlsContext,
  TitleContext,
  RightButtonContext,
  PageLayoutContext,
} from './Contexts';

class HeaderFrame extends React.Component {
  static propTypes = {
    toggleNavVisibility: PropTypes.func,
    back: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    showVenueSelectorInsideHeader: PropTypes.bool,
    children: PropTypes.node,
    index: PropTypes.number,
  };

  state = {
    titleRef: null,
    controlsRef: null,
  };

  constructor(props) {
    super(props);
    this.backNavLinkRef = React.createRef();
    this.headerRef = React.createRef();
    this.titleRef = React.createRef();
    this.controlsRef = React.createRef();
    this.rightButtonRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      backNavLinkRef: this.backNavLinkRef,
      headerRef: this.headerRef,
      titleRef: this.titleRef,
      controlsRef: this.controlsRef,
      rightButtonRef: this.rightButtonRef,
    });
  }

  renderLeftButton() {
    const { index, toggleNavVisibility, back } = this.props;
    if (index === 0) {
      return (
        <button type="button" className="app__hamburger-button" onClick={toggleNavVisibility}>
          <SvgHamburger />
        </button>
      );
    }

    return (
      <button type="button" className="app__hamburger-button" onClick={back}>
        <SvgArrow direction="left" />
      </button>
    );
  }

  render() {
    const { children, isAuthenticated, showVenueSelectorInsideHeader } = this.props;
    const { backNavLinkRef, headerRef, titleRef, controlsRef, rightButtonRef } = this.state;
    if (!isAuthenticated) {
      return children;
    }

    return (
      <>
        <PageLayoutContext.Consumer>
          {({ headerTop, layoutInfo }) => {
            const { hideVenueSelector, pageLayout } = layoutInfo;
            const mods = {
              wide: pageLayout === 'wide',
              narrow: pageLayout === 'narrow',
            };
            return (
              <>
                <header ref={this.headerRef} className="app__header" style={{ top: `${headerTop}px` }}>
                  {this.renderLeftButton()}
                  <div className="app__backnav-link" ref={this.backNavLinkRef} />
                  <h2 className="app__title" ref={this.titleRef} />
                  {!hideVenueSelector && showVenueSelectorInsideHeader && <VenueSelector useHeaderStyle />}
                  <div className="app__right-button" ref={this.rightButtonRef} />
                </header>
                {!hideVenueSelector && !showVenueSelectorInsideHeader && <VenueSelector useHeaderStyle />}
                <section ref={this.controlsRef} className={withMods('app__controls', mods)} />
              </>
            );
          }}
        </PageLayoutContext.Consumer>
        <HeaderContext.Provider value={headerRef}>
          <ControlsContext.Provider value={controlsRef}>
            <TitleContext.Provider value={titleRef}>
              <BackNavLinkContext.Provider value={backNavLinkRef}>
                <RightButtonContext.Provider value={rightButtonRef}>{children}</RightButtonContext.Provider>
              </BackNavLinkContext.Provider>
            </TitleContext.Provider>
          </ControlsContext.Provider>
        </HeaderContext.Provider>
        <PrivacyFooter />
      </>
    );
  }
}

export default HeaderFrame;
